// What's on screen lives in the URL so a refresh or a shared link reopens it:
// ?pub=w123 (the open pub), &t=2026-07-17T18:00Z (the hour a share was made
// for) and the filters (?f=…&chain=…, see filters.ts).

import { writeFilters, type Filters } from './filters';
import { HOUR_MS } from './time';

const PUB_ID = /^[nwr]\d{1,12}$/;
/** An ISO hour: 2026-07-17T18:00Z (or with :00 seconds / an offset). */
const ISO_HOUR = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/;

export function readPubParam(search = window.location.search): string | null {
  const id = new URLSearchParams(search).get('pub');
  return id && PUB_ID.test(id) ? id : null;
}

/** The shared hour (start of the hour, epoch ms), or null if absent or nonsense. */
export function readTimeParam(search = window.location.search): number | null {
  const t = new URLSearchParams(search).get('t');
  if (!t || !ISO_HOUR.test(t)) return null;
  const ms = Date.parse(t);
  return Number.isFinite(ms) ? Math.floor(ms / HOUR_MS) * HOUR_MS : null;
}

/** "2026-07-17T18:00Z" for an hour. */
export function isoHour(ms: number): string {
  return `${new Date(Math.floor(ms / HOUR_MS) * HOUR_MS).toISOString().slice(0, 16)}Z`;
}

function replace(url: URL) {
  window.history.replaceState(null, '', url);
}

/** Set or clear the open pub. Opening or closing a pub drops any shared hour. */
export function writePubParam(id: string | null): void {
  const url = new URL(window.location.href);
  if (id) url.searchParams.set('pub', id);
  else url.searchParams.delete('pub');
  url.searchParams.delete('t');
  replace(url);
}

export function writeFiltersParam(filters: Filters): void {
  replace(writeFilters(new URL(window.location.href), filters));
}

/** The link to share: a pub and an hour on the given origin. */
export function shareUrl(origin: string, pubId: string, hour: number): string {
  const url = new URL('/', origin);
  url.searchParams.set('pub', pubId);
  url.searchParams.set('t', isoHour(hour));
  return url.toString();
}
